export default "__VITE_ASSET__CFNB$qvc__"